export default "__VITE_ASSET__B96Wr1sJ__"